import request from 'api/request';

export default function fetchEvents(id) {
  return request({ url: `/courses/${id}/statistics/events` });
}
